import { APIHelpSection } from '@partnerconnect-monorepo/types/HelpSection';
import { Action } from '../../../constants/action';
import { Button } from '@partnerconnect-monorepo/ui/components/ui/button';
import {
  Card,
  CardContent,
  CardHeader
} from '@partnerconnect-monorepo/ui/components/ui/card';
import { TabsContent } from '@partnerconnect-monorepo/ui/components/ui/tabs';
import { T } from '@transifex/react';
import { PencilIcon } from 'lucide-react';
import { Dispatch, SetStateAction } from 'react';
import { HelpSectionEditForm } from './HelpSectionEditForm/HelpSectionEditForm.connect';

interface HelpSectionViewProps {
  helpSection: APIHelpSection;
  isEditing: boolean;
  setIsEditing: Dispatch<SetStateAction<boolean>>;
}

export const HelpSectionView = ({
  helpSection,
  isEditing,
  setIsEditing
}: HelpSectionViewProps) => (
  <TabsContent value={'' + helpSection.id}>
    <Card>
      {isEditing ? (
        <HelpSectionEditForm
          helpSection={helpSection}
          closeForm={() => setIsEditing(false)}
        />
      ) : (
        <>
          <CardHeader className="flex justify-between items-baseline">
            <h4>{helpSection.title}</h4>
            {helpSection.actions.map((action) => {
              switch (action.value) {
                case Action.Edit:
                  return (
                    <Button
                      key={action.value}
                      size="sm"
                      onClick={() => setIsEditing(true)}
                    >
                      <PencilIcon />
                      <T _str="Edit" />
                    </Button>
                  );
                default:
                  return null;
              }
            })}
          </CardHeader>
          <CardContent>
            <div
              className="
                [&_a]:underline
                [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6
                [&_table]:w-full [&_table]:my-4 [&_table]:border-collapse [&_table]:border [&_table]:border-border
                [&_th]:border [&_th]:border-border [&_th]:bg-muted/50 [&_th]:px-3 [&_th]:py-2 [&_th]:text-left
                [&_td]:border [&_td]:border-border [&_td]:px-3 [&_td]:py-2
              "
              dangerouslySetInnerHTML={{
                __html: helpSection.body
              }}
            />
          </CardContent>
        </>
      )}
    </Card>
  </TabsContent>
);
